// slideshow
setTimeout(
  function() 
  {
    if($(window).width() < 480) {
      	$('.flickity-viewport').attr('style', 'min-height:250px');
    }
    else if($(window).width() < 720) {
    	$('.flickity-viewport').attr('style', 'min-height:350px');
    }
  }, 500
);


setTimeout(function(){
   var cw = $('a.instagram-photo img').width();
	$('a.instagram-photo img').css({'height':cw+'px'});
}, 1000);


// drawer menu: expand submenu only when parent has no real link
$( ".header-drawer .navigation a.main-nav-item" ).click(function(e) {
	var href = $(this).attr("href");
	if ($(window).width() < 1020 && (!href || href === "#")) {
		e.preventDefault();
		$(this).siblings("ul.secondary").toggle();
	}
});


// quantity update in cart
const pricePerUnit = {
  "flower-day": ['4.00', '4.50', '4.40', '4.30', '4.20', '4.10', '4.00', '4.00'],
  "flower-night": ['4.30', '4.80', '4.70', '4.60', '4.50', '4.40', '4.30', '4.30'],
  "extra-long": ['4.30', '5.00', '4.90', '4.80', '4.70', '4.60', '4.50', '4.40'],
  "product-1": ['3.50', '4.20', '4.10', '4.00', '3.90', '3.80', '3.70', '3.60'],
  "tampon-super": ['3.60', '4.30', '4.20', '4.10', '4.00', '3.90', '3.80', '3.70'],
  "tampon-super-plus": ['3.80', '4.50', '4.40', '4.30', '4.20', '4.10', '4.00', '3.90'],
  "epan-vamvakero-esorouxo-periodou-classic": ['18.00'],
  "epan-vamvakero-esorouxo-periodou-elegant": ['18.00']
}

async function getProductsVariants() {
  const response = await fetch("/products.json");
  const jsonData = await response.json();
  const products = jsonData.products;
  const productVariants = {};
  products.forEach(pr => { productVariants[pr.handle] = pr.variants });

  console.log('productVariants', productVariants)
  return productVariants;
}

async function removeItemFromCart(index) {
  await fetch("/cart/change.js", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: index,
      quantity: 0,
    }),
  })
}

function addToCart(variantId, qty) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        'items': [{
          'id': variantId,
          'quantity': qty
        }]
    })
  })
  .then(() => {
    self.location.href = '#cart-table';
    window.location.reload(true);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function disableButtons() {
  $(".cart-item-quantity-minus, .cart-item-quantity-plus").prop('disabled', true);
}

document.addEventListener( 'DOMContentLoaded',  async function () {
  const productsVariants = await getProductsVariants();
  
  $(".cart-item-quantity-minus").click(async function() {
    console.log('minus')
    const qtyEl = $(this).siblings("input[type='text'].cart-item-quantity-display");
    const oldQty = qtyEl.val();
    
    if(!isNaN(oldQty) || oldQty < 0) {
      disableButtons();
      const index = $(this).parents(".cart-item-quantity").data("index");
      const handle = $(this).parents(".cart-item-quantity").data("product-handle");
      const newQty = parseInt(oldQty) - 1;
      // const variantName = pricePerUnit[handle][newQty] || pricePerUnit[handle][0];

      const productId = $(this).closest('.cart-item[data-variant]').attr('data-product-id');
      
      let variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // if (productId === "14963374653784" || productId === "14932797423960") {
      //   variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // } else {
      //   variantId = productsVariants[handle].find(variant => variant.title === "ΠΟΣΟΤΗΤΑ / " + variantName + "€ το τεμάχιο").id;
      // }
      
      qtyEl.val(newQty);
      await removeItemFromCart(index);
  
      if(newQty > 0) {
        addToCart(variantId, newQty);
      }
      else {
        self.location.href = '#cart-table';
        window.location.reload(true);
      }
    }
    else {
      alert("Παρακαλώ εισάγετε έναν έγκυρο αριθμό.");
    }
  });

  $(".cart-item-quantity-plus").click(async function() {
    const qtyEl = $(this).siblings("input[type='text'].cart-item-quantity-display");
    const oldQty = qtyEl.val();
    
    if(!isNaN(oldQty) || oldQty < 0) {
      disableButtons();
      const index = $(this).parents(".cart-item-quantity").data("index");
      const handle = $(this).parents(".cart-item-quantity").data("product-handle");
      const newQty = parseInt(oldQty) + 1;
      // const variantName = pricePerUnit[handle][newQty] || pricePerUnit[handle][0];
      
      const productId = $(this).closest('.cart-item[data-variant]').attr('data-product-id');
      let variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // if (productId === "14963374653784" || productId === "14932797423960") {
      //   variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // } else {
      //   console.log('productsVariants[handle]', productsVariants[handle][0].id);
      //   variantId = productsVariants[handle].find(variant => variant.title === "ΠΟΣΟΤΗΤΑ / " + variantName + "€ το τεμάχιο").id;
      // }
  
      qtyEl.val(newQty);
      await removeItemFromCart(index);
      addToCart(variantId, newQty);
    }
    else {
      alert("Παρακαλώ εισάγετε έναν έγκυρο αριθμό.");
    }
  });

  $("input[type='text'].cart-item-quantity-display").change(async function() {
    const qty = $(this).val();
    
    if(!isNaN(qty) || qty < 0) {
      disableButtons();
      const index = $(this).parents(".cart-item-quantity").data("index");
      const handle = $(this).parents(".cart-item-quantity").data("product-handle"); 
      // const variantName = pricePerUnit[handle][qty] || pricePerUnit[handle][0];
      //const variantId = productsVariants[handle].find(variant => variant.title === "ΠΟΣΟΤΗΤΑ / " + variantName + "€ το τεμάχιο").id;
      const variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
  
      await removeItemFromCart(index);
      addToCart(variantId, qty);
    }
    else {
      alert("Παρακαλώ εισάγετε έναν έγκυρο αριθμό.");
    }
  });

  $(".delete-cart-item-btn").click(async function() {
    const index = $(this).parent().data("index") || $(this).parents(".cart-item-quantity").data("index");
    await removeItemFromCart(index);
    location.reload();
  });

});

function shopifyRoot() {
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    return window.Shopify.routes.root;
  }
  return "/";
}

function updateCartCountDisplay(count) {
  const countText = String(count);

  $("#counter").text(countText);

  $("header .header-actions .cart-count #counter").text(countText);
}

function optimisticCartIncrement(amount) {
  const counter = document.getElementById("counter");
  if (!counter) {
    return;
  }

  const nextCount = (parseInt(counter.textContent, 10) || 0) + amount;
  updateCartCountDisplay(nextCount);
}

function refreshCartCounter() {
  if (window.Shopify && typeof window.Shopify.getCart === "function") {
    return new Promise(function (resolve) {
      window.Shopify.getCart(function (cart) {
        updateCartCountDisplay(cart.item_count);
        resolve(cart);
      });
    });
  }

  return fetch(shopifyRoot() + "cart.js", {
    cache: "no-store",
    headers: { "Cache-Control": "no-cache" },
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      updateCartCountDisplay(cart.item_count);
      return cart;
    });
}

function addOneToCart(variantId) {
  return $.ajax({
    type: "POST",
    url: shopifyRoot() + "cart/add.js",
    data: "quantity=1&id=" + variantId,
    dataType: "json",
  }).then(function () {
    optimisticCartIncrement(1);
    return refreshCartCounter();
  });
}

async function quickAddToCart(trigger) {
  const handle = trigger.getAttribute("data-product-handle");
  if (!handle || trigger.classList.contains("is-loading")) {
    return;
  }

  const originalText = trigger.textContent.trim();
  trigger.classList.add("is-loading");
  trigger.textContent = "...";

  try {
    const response = await fetch(shopifyRoot() + "products/" + handle + ".js");
    if (!response.ok) {
      throw new Error("Product not found");
    }

    const product = await response.json();
    const variant = product.variants.find(function (item) {
      return item.available;
    });

    if (!variant) {
      window.location.href = shopifyRoot() + "products/" + handle;
      return;
    }

    await addOneToCart(variant.id);

    trigger.classList.remove("is-loading");
    trigger.classList.add("is-success");
    trigger.textContent = "Προστέθηκε!";
    setTimeout(function () {
      trigger.classList.remove("is-success");
      trigger.textContent = originalText;
    }, 2500);
  } catch (error) {
    console.error(error);
    trigger.classList.remove("is-loading");
    trigger.textContent = originalText;
    window.location.href = shopifyRoot() + "products/" + handle;
  }
}

$(document).on("click", ".js-quick-add-to-cart", function (event) {
  event.preventDefault();
  quickAddToCart(this);
});

// Homepage image overlay carousel (Swiper)
(function () {
  var carouselInstances = {};
  var MOBILE_MEDIA_QUERY = window.matchMedia("(max-width: 720px)");
  var IOS_VIDEO_UNLOCKED = false;

  function isIOSDevice() {
    return (
      /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
  }

  function getSectionEl(container) {
    return container.closest(
      '[data-section-type="image-with-text-overlay-carousel"]'
    );
  }

  function destroyCarousel(sectionId) {
    if (!carouselInstances[sectionId]) {
      return;
    }
    carouselInstances[sectionId].destroy(true, true);
    delete carouselInstances[sectionId];
  }

  function pauseCarouselVideos(container) {
    if (!container) {
      return;
    }

    container.querySelectorAll(".image-overlay-carousel__video").forEach(function (video) {
      video.pause();
    });

    container.querySelectorAll("[data-carousel-youtube]").forEach(function (embed) {
      var ytPlayer = window.jQuery ? window.jQuery(embed).data("ytPlayer") : null;
      if (ytPlayer && ytPlayer.player && ytPlayer.player.pauseVideo) {
        ytPlayer.player.pauseVideo();
      }
    });
  }

  function initCarouselYoutubeEmbed(embed) {
    if (!embed || embed.getAttribute("data-yt-ready") === "true") {
      return;
    }

    if (!window.jQuery || typeof window.jQuery.fn.YTPlayer === "undefined") {
      return;
    }

    var videoId = embed.getAttribute("data-video-id");
    if (!videoId) {
      return;
    }

    embed.setAttribute("data-yt-ready", "true");

    window.jQuery(embed).YTPlayer({
      fitToBackground: true,
      videoId: videoId,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        controls: 0,
        modestbranding: 1,
        mute: 1,
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        origin: window.location.origin,
        wmode: "transparent",
      },
    });
  }

  function initCarouselYoutubeEmbeds(slide) {
    if (!slide) {
      return;
    }

    slide.querySelectorAll("[data-carousel-youtube]").forEach(initCarouselYoutubeEmbed);
  }

  function getVisibleSlideVideo(slide) {
    if (!slide) {
      return null;
    }

    return slide.querySelector(".image-overlay-carousel__video");
  }

  function getVisibleSlideEmbed(slide) {
    if (!slide) {
      return null;
    }

    var isMobile = MOBILE_MEDIA_QUERY.matches;
    var mobileEmbed = slide.querySelector(
      ".image-overlay-carousel__embed-wrap--mobile .image-overlay-carousel__embed"
    );
    var desktopEmbed = slide.querySelector(
      ".image-overlay-carousel__embed-wrap--desktop .image-overlay-carousel__embed"
    );
    var fallbackEmbed = slide.querySelector(".image-overlay-carousel__embed");

    if (isMobile && mobileEmbed) {
      return mobileEmbed;
    }

    if (desktopEmbed) {
      return desktopEmbed;
    }

    if (mobileEmbed) {
      return mobileEmbed;
    }

    return fallbackEmbed;
  }

  function pickVideoSrc(video) {
    if (!video) {
      return "";
    }

    var mobileSrc = video.getAttribute("data-video-mobile");
    var desktopSrc = video.getAttribute("data-video-desktop");
    var isMobile = MOBILE_MEDIA_QUERY.matches;

    if (isMobile && mobileSrc) {
      return mobileSrc;
    }

    if (desktopSrc) {
      return desktopSrc;
    }

    return mobileSrc || "";
  }

  function configureVideoElement(video) {
    if (!video) {
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.removeAttribute("poster");
  }

  function applyVideoSrc(video, forceReload) {
    if (!video) {
      return false;
    }

    var nextSrc = pickVideoSrc(video);
    if (!nextSrc) {
      return false;
    }

    var currentSrc = video.getAttribute("data-active-src");
    if (!forceReload && currentSrc === nextSrc && video.currentSrc) {
      return true;
    }

    video.setAttribute("data-active-src", nextSrc);
    video.src = nextSrc;
    video.load();
    return true;
  }

  function markVideoReady(video) {
    if (!video) {
      return;
    }

    video.classList.add("is-video-ready");
  }

  function tryPlayVideo(video, attempt) {
    if (!video) {
      return;
    }

    attempt = attempt || 0;
    configureVideoElement(video);

    var playPromise = video.play();
    if (!playPromise || typeof playPromise.catch !== "function") {
      markVideoReady(video);
      return;
    }

    playPromise
      .then(function () {
        markVideoReady(video);
      })
      .catch(function () {
        if (attempt < 5) {
          window.setTimeout(function () {
            tryPlayVideo(video, attempt + 1);
          }, 250 * (attempt + 1));
          return;
        }

        markVideoReady(video);
      });
  }

  function bindVideoReadyEvents(video, shouldAutoplay) {
    if (!video || video.getAttribute("data-ready-bound") === "true") {
      return;
    }

    video.setAttribute("data-ready-bound", "true");

    var handled = false;

    function handleReady() {
      if (handled) {
        return;
      }

      handled = true;
      markVideoReady(video);
      if (shouldAutoplay) {
        tryPlayVideo(video);
      }
    }

    ["loadedmetadata", "loadeddata", "canplay"].forEach(function (eventName) {
      video.addEventListener(eventName, handleReady, { once: true });
    });

    window.setTimeout(function () {
      if (video.readyState >= 1) {
        handleReady();
      }
    }, 2000);
  }

  function resetSlideVideos(slide) {
    if (!slide) {
      return;
    }

    slide.querySelectorAll(".image-overlay-carousel__video").forEach(function (video) {
      video.classList.remove("is-video-ready");
      video.removeAttribute("data-ready-bound");
      video.removeAttribute("data-active-src");
      video.removeAttribute("poster");
    });
  }

  function syncSlideVideoLoop(slide) {
    if (!slide) {
      return;
    }

    var loopEnabled = slide.getAttribute("data-video-loop") === "true";
    slide.querySelectorAll(".image-overlay-carousel__video").forEach(function (video) {
      video.loop = loopEnabled;
    });
  }

  function prepareSlideVideo(slide, forceReload) {
    if (!slide) {
      return;
    }

    syncSlideVideoLoop(slide);

    var video = getVisibleSlideVideo(slide);
    if (!video) {
      return;
    }

    configureVideoElement(video);

    if (!applyVideoSrc(video, forceReload)) {
      return;
    }

    var shouldAutoplay = slide.getAttribute("data-video-autoplay") === "true";
    bindVideoReadyEvents(video, shouldAutoplay);
  }

  function playSlideVideo(slide, options) {
    options = options || {};

    if (!slide) {
      return;
    }

    prepareSlideVideo(slide, options.forceReload);

    if (slide.getAttribute("data-video-autoplay") !== "true") {
      return;
    }

    var embed = getVisibleSlideEmbed(slide);
    if (embed) {
      initCarouselYoutubeEmbed(embed);
      return;
    }

    var video = getVisibleSlideVideo(slide);
    if (!video) {
      return;
    }

    tryPlayVideo(video);
  }

  function getActiveSlide(container) {
    if (!container) {
      return null;
    }

    return (
      container.querySelector(".swiper-slide-active") ||
      container.querySelector(".swiper-slide")
    );
  }

  function manageCarouselVideos(container, activeSlide, options) {
    if (!container) {
      return;
    }

    container.querySelectorAll(".swiper-slide").forEach(resetSlideVideos);
    pauseCarouselVideos(container);
    playSlideVideo(activeSlide || getActiveSlide(container), options);
  }

  function initImageOverlayCarousel(container) {
    if (!container || typeof Swiper === "undefined") {
      return;
    }

    var sectionEl = getSectionEl(container);
    if (!sectionEl) {
      return;
    }

    var sectionId = String(sectionEl.getAttribute("data-section-id"));
    var slides = container.querySelectorAll(".swiper-slide");

    if (slides.length < 2) {
      manageCarouselVideos(container);
      return;
    }

    destroyCarousel(sectionId);

    var autoplayEnabled = sectionEl.getAttribute("data-autoplay") === "true";
    var delay =
      parseInt(sectionEl.getAttribute("data-autoplay-delay"), 10) || 5000;
    var loopEnabled = sectionEl.getAttribute("data-loop") === "true";
    var paginationEl = container.querySelector(".swiper-pagination");
    var nextEl = container.querySelector(
      ".image-overlay-carousel__arrow--next"
    );
    var prevEl = container.querySelector(
      ".image-overlay-carousel__arrow--prev"
    );

    var swiper = new Swiper(container, {
      init: false,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: loopEnabled,
      speed: 800,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      simulateTouch: true,
      allowTouchMove: true,
      touchEventsTarget: "container",
      touchRatio: 1,
      touchAngle: 40,
      threshold: 8,
      shortSwipes: true,
      longSwipes: true,
      followFinger: true,
      touchReleaseOnEdges: true,
      touchStartPreventDefault: false,
      passiveListeners: false,
      autoplay: autoplayEnabled
        ? { delay: delay, disableOnInteraction: false }
        : false,
      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : false,
      navigation:
        nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
    });

    swiper.on("init", function () {
      container.classList.add("is-carousel-ready");
      if (swiper.autoplay && autoplayEnabled) {
        swiper.autoplay.start();
      }
      manageCarouselVideos(container, getActiveSlide(container));
    });

    swiper.on("slideChangeTransitionEnd", function () {
      manageCarouselVideos(container, getActiveSlide(container));
    });

    swiper.init();
    carouselInstances[sectionId] = swiper;
  }

  function initAllImageOverlayCarousels() {
    document
      .querySelectorAll("[data-image-overlay-carousel]")
      .forEach(initImageOverlayCarousel);
  }

  function unlockIOSVideos() {
    if (IOS_VIDEO_UNLOCKED) {
      return;
    }

    IOS_VIDEO_UNLOCKED = true;
    document
      .querySelectorAll("[data-image-overlay-carousel]")
      .forEach(function (container) {
        manageCarouselVideos(container, getActiveSlide(container), {
          forceReload: true,
        });
      });
  }

  function bindIOSVideoUnlock() {
    if (!isIOSDevice()) {
      return;
    }

    var unlock = function () {
      unlockIOSVideos();
      document.removeEventListener("touchstart", unlock, true);
      document.removeEventListener("click", unlock, true);
    };

    document.addEventListener("touchstart", unlock, true);
    document.addEventListener("click", unlock, true);
  }

  function bindCarouselLifecycle() {
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) {
        return;
      }

      document
        .querySelectorAll("[data-image-overlay-carousel]")
        .forEach(function (container) {
          manageCarouselVideos(container, getActiveSlide(container), {
            forceReload: true,
          });
        });
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        document
          .querySelectorAll("[data-image-overlay-carousel]")
          .forEach(pauseCarouselVideos);
        return;
      }

      document
        .querySelectorAll("[data-image-overlay-carousel]")
        .forEach(function (container) {
          manageCarouselVideos(container, getActiveSlide(container));
        });
    });
  }

  $(document).ready(function () {
    initAllImageOverlayCarousels();
    bindIOSVideoUnlock();
    bindCarouselLifecycle();
  });

  if (MOBILE_MEDIA_QUERY.addEventListener) {
    MOBILE_MEDIA_QUERY.addEventListener("change", function () {
      document
        .querySelectorAll("[data-image-overlay-carousel]")
        .forEach(function (container) {
          manageCarouselVideos(container, getActiveSlide(container), {
            forceReload: true,
          });
        });
    });
  }

  $(document).on("shopify:section:load", function (event) {
    var section = document.getElementById(
      "shopify-section-" + event.detail.sectionId
    );
    if (!section) {
      return;
    }
    var container = section.querySelector("[data-image-overlay-carousel]");
    if (container) {
      window.setTimeout(function () {
        initImageOverlayCarousel(container);
      }, 50);
    }
  });

  $(document).on("shopify:section:unload", function (event) {
    destroyCarousel(String(event.detail.sectionId));
  });
})();

